import request from '@/utils/request'

//特色展厅列表查询
export function getExhibitionAreaList(params) {
  return request({
    url: '/api/exhibitionAreaAppointment/getExhibitionAreaList',
    method: 'get',
    params
  });
}

//特色展厅详情
export function getExhibitionAreaDetail(params) {
  return request({
    url: '/api/exhibitionAreaAppointment/getExhibitionAreaDetail',
    method: 'get',
    params
  });
}
//常设展区列表查询查询
export function findArea(params) {
  return request({
    url: '/api/exhibitionPermanent/exhibitionPermanent/list',
    method: 'get',
    params
  });
}
//常设展项列表查询
export function findExhibition(params) {
  return request({
    url: '/api/exhibition/exhibitionNormal/list',
    method: 'get',
    params
  });
}
//常设展项详情
export function getPermanentInfo(params) {
  return request({
    url: '/api/exhibitionPermanent/exhibitionPermanent/info',
    method: 'get',
    params
  });
}
//临时展区列表查询查询
export function findtemporaryArea(params) {
  return request({
    url: '/api/exhibitiontemp/exhibitiontemporary/list',
    method: 'get',
    params
  });
}
//临时展区详情
export function gettemporaryInfo(params) {
  return request({
    url: '/api/exhibitiontemp/exhibitiontemporary/info',
    method: 'get',
    params
  });
}
//展览点赞
export function saveLiked(params) {
  return request({
    url: '/api/exhibition/exhibitiontemppermliked/save',
    method: 'get',
    params
  });
}
// 取消展览点赞
export function deletetLiked(params) {
  return request({
    url: '/api/exhibition/exhibitiontemppermliked/delete',
    method: 'get',
    params
  });
}
// 临时展览分享
export function temporaryshared(params) {
  return request({
    url: '/api/exhibitiontemp/exhibitiontemporary/shared',
    method: 'get',
    params
  });
}
// 常设展览分享
export function permanentshared(params) {
  return request({
    url: '/api/exhibitionPermanent/exhibitionPermanent/shared',
    method: 'get',
    params
  });
}
// 点赞展览
export function exhibitionliked(params) {
  return request({
    url: '/api/exhibition/exhibitiontemppermliked/list',
    method: 'get',
    params
  });
}
// 常设展览展品
export function getCommonlist(params) {
  return request({
    url: '/api/exhibitionpermanent/exhibitionpermanenexhibition/list',
    method: 'get',
    params
  });
}



// WEBPACK FOOTER //
// ./src/api/navigation/index.js